CustomTC.define('jquery/ajax/var/rquery',[],function() {
	return (/\?/);
});

